import Model from "../Model";

class orders extends Model{

    buildUrl ({ param }) {
        return ['retail/orders', param];
    }

    all(config = {}) {
        return this.request({ method: 'GET', action: 'all', ...config });
    }
}


export default new orders;